import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import OfficeAccountTable from "./view/OfficeAccountTable";

export const OfficeAccount = () => {
  const viewAccount =
    PERMISSIONS.permission_utilities_officeconfiguration_officeaccount_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewAccount) && (
        <>
          <OfficeAccountTable />
        </>
      )}
    </>
  );
};

export default OfficeAccount;
